import { useEffect } from "react"
import lockupUrl from "./keel-lockup.svg"
import markUrl from "./keel-mark.svg"

/**
 * Keel logos, from the client's design-system files (keel-lockup.svg, keel-mark.svg), drawn as
 * images so the artwork is never retyped, recoloured or restyled. Abyss ink on white only: no
 * rounded corners, outlines, gradients or shadows, and the brass line always stays. The files'
 * viewBoxes already include the clear space (one K-stem width) on every side.
 */

/** KEEL wordmark on the brass bar. Never narrower than 72px. */
export function KeelLockup({ width = 112, className }: { width?: number; className?: string }) {
  const w = Math.max(72, width)
  return <img src={lockupUrl} alt="Keel" width={w} height={Math.round((w * 100) / 266)} className={className} draggable={false} />
}

/** K on the brass bar. Never smaller than 16px. */
export function KeelMark({ size = 32, className, label = "Keel" }: { size?: number; className?: string; label?: string }) {
  const s = Math.max(16, size)
  return <img src={markUrl} alt={label} width={s} height={s} className={className} draggable={false} />
}

/** Browser tab title: "Keel" on its own, "Page · Keel" for a page. */
export function usePageTitle(page?: string | null) {
  useEffect(() => {
    document.title = page ? `${page} · Keel` : "Keel"
  }, [page])
}
